import React from 'react'

import { Image } from '@chatterbug/aaron'

import tutorIcon from './tutorIcon.svg'

export default () => {
  return <Image width={26} height={26} src={tutorIcon} />
}
